import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import { PrimaryLightButton } from "@assets/buttons";

const DashboardExcelButton = ({ onClick }) => {
  return (
    <Grid container sx={{ mt: 2.75 }}>
      <PrimaryLightButton
        variant="contained"
        sx={{ width: "100%", boxShadow: 0 }}
        onClick={onClick}
      >
        엑셀 다운로드
      </PrimaryLightButton>
    </Grid>
  );
};

export default DashboardExcelButton;

DashboardExcelButton.propTypes = {
  onClick: PropTypes.func,
};
